import request from "superagent";

export const GET_AUTH_URL = "user/GET_AUTH_URL";
export const GET_AUTH_URL_DATA_RECEIVED = "user/GET_AUTH_URL_DATA_RECEIVED";
export const GET_AUTH_URL_ERROR = "user/GET_AUTH_URL_ERROR";

export default function userServiceFactory(store, next, action) {
  return {
    [GET_AUTH_URL]: () => {
      request
        .get("/api/public/getAuthUrl")
        .query({ username: action.username })
        .catch(err => {
          return next({
            type: GET_AUTH_URL_ERROR,
            err: err
          });
        })
        .then(res => {
          const data = res.body;

          return next({
            type: GET_AUTH_URL_DATA_RECEIVED,
            data
          });
        });
    }
  };
}



// WEBPACK FOOTER //
// ./src/services/user/index.js